import { Page } from "@/ui";

/**
 * Rendered outside `AppShell` — a bare catch-all route (`App.tsx` `path="*"`).
 * `<Page>` still roots it (D-15 rule 1); `min-h-dvh` gives it its own height
 * context since no shell ancestor provides one here.
 */
export function NotFound() {
  return (
    <Page className="min-h-dvh items-center justify-center px-6 text-center">
      <div>
        <h1 className="text-2xl text-ink">Page not found</h1>
        <p className="mt-2 text-muted">The link you followed does not exist.</p>
      </div>
    </Page>
  );
}
